import { render, staticRenderFns } from "./UploadScreen.vue?vue&type=template&id=0c403403&scoped=true"
import script from "./UploadScreen.vue?vue&type=script&lang=js"
export * from "./UploadScreen.vue?vue&type=script&lang=js"
import style0 from "./UploadScreen.vue?vue&type=style&index=0&id=0c403403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c403403",
  null
  
)

export default component.exports